import { render, staticRenderFns } from "./ReportFieldUpload.vue?vue&type=template&id=fa1008a6"
import script from "./ReportFieldUpload.vue?vue&type=script&lang=js"
export * from "./ReportFieldUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports